module.exports = __webpack_public_path__ + "img/AdvancedPowerArmorMark2.aa5957aa.gif";